const pushEventDataLayer = (
  event,
  category,
  action,
  label,
  nameValue,
  value = ''
) => {
  try {
    // trackEvent
    window.dataLayer = window.dataLayer || []
    const data = {
      event: event,
      eventCategory: category,
      eventAction: action,
      eventLabel: label
      
    }
    window.dataLayer.push(nameValue ? {...data, [nameValue]: value}: data)

    if (process.env.ENVIRONMENT === 'DEV') {
      console.log('===PUSH  DATALAYER')
      console.log('event: ', event)
      console.log('category: ', category)
      console.log('label: ', label)
      console.log('action: ', action)
      console.log('===PUSH  DATALAYER')
    }
  } catch (e) {
    console.log('Datalayer Error')
  }
}
export default pushEventDataLayer

